import React from 'react'
import {connect} from 'react-redux'

import axios from 'axios'

import {Label,Input,Radio,Form,FormCell,CellBody,CellFooter,CellHeader,Button,Toptips} from 'react-weui';
import {Page,Pay} from '../../components'
import '../../css/page/LectureRegistrationPage.css'


class LectureRegistrationPage extends React.Component {
    constructor() {
        super();
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangePhone = this.handleChangePhone.bind(this);
        this.handleChangeWC = this.handleChangeWC.bind(this);
        this.handleChangeCount = this.handleChangeCount.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeCity = this.handleChangeCity.bind(this);
        this.state = {
            name: '',
            phone: '',
            wc: '',
            city: '深圳',
            count: 0,
            showTopTips: false,
            tipsWord: '',
            reg: /^\+?[1-9]\d*$/
        }
    }
    handleChangeName(e) {
        this.setState({name: e.target.value})
    }
    handleChangePhone(e) {
        this.setState({phone: e.target.value})
    }
    handleChangeWC(e) {
        this.setState({wc: e.target.value})
    }
    handleChangeCount(e) {
        this.setState({count: +e.target.value})
        if(! this.state.reg.test(+e.target.value)){
            this.setState({
                showTopTips: true,
                tipsWord: '请正确填写购买数量!'
            })
            return;
        }
        this.setState({
            showTopTips: false
        })
    }
    handleChangeCity(e){
        this.setState({city: e.target.value})
    }
    handleSubmit() {
        if(!this.state.name || !this.state.phone || !this.state.wc){
            this.setState({
                showTopTips: true,
                tipsWord: '请完善信息!'
            })
            return;
        }else if(!this.state.reg.test(this.state.count)){
            this.setState({
                showTopTips: true,
                tipsWord: '请正确填写购买数量!'
            })
            return;
        }else {
            this.setState({
                showTopTips: false
            })
            let lecture_id = this.props.location.query.lecture_id;
            let data = new FormData();
            data.append('city', this.state.city)
            data.append('name', this.state.name)
            data.append('telephone',this.state.phone)
            data.append('wechat',this.state.wc)
            axios.post(`/api/activity/signup/${lecture_id}/submit`, data)
            .then(res => {
                if(res.data.code === 0){
                    this.props.dispatch({
                        type: 'PAY_LECTURE',
                        payload: {
                            params: {
                                product: 'pay_lecture',
                                lecture_id: lecture_id,
                                inviter_id: this.props.location.query.inviter_id,
                                count: this.state.count
                            },
                            success: () => {
                                window.location.replace(`/lecture/${lecture_id}/paysuccess`)
                            },
                            fail: (data) => {
                                // alert('fail')
                            }
                        }
                    })
                }else{
                    alert(res.data.msg);
                }
            })
        }
    }
    render(){
        return (
            <Page>
                <div className="Lecture-registration-page">
                    <Pay/>
                    <div className="Lecture-registration-page__title">
                        报名信息
                        <p>（此信息为登记获取电子入场券的唯一凭证，</p>
                        <p>请务必填写。）</p>
                    </div>      
                    <Form>
                        <FormCell>
                            <CellHeader>
                                <Label>姓名：</Label>
                            </CellHeader>
                            <CellBody>
                                <Input type="text" placeholder="请输入姓名" onChange={this.handleChangeName}/>
                            </CellBody>
                        </FormCell>
                        <FormCell>
                            <CellHeader>
                                <Label>手机号：</Label>
                            </CellHeader>
                            <CellBody>
                                <Input type="tel" placeholder="请输入手机号" onChange={this.handleChangePhone}/>
                            </CellBody>
                        </FormCell>
                        <FormCell>
                            <CellHeader>
                                <Label>微信号：</Label>
                            </CellHeader>
                            <CellBody>
                                <Input type="text" placeholder="请输入微信号" onChange={this.handleChangeWC}/>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <Form checkbox >
                        <FormCell>
                            <Label>城市：</Label>
                        </FormCell>
                        <FormCell radio>
                            <CellHeader>
                                <Radio name="radio1" value="深圳" onChange={this.handleChangeCity} defaultChecked/>
                            </CellHeader>
                            <CellBody>深圳</CellBody>
                        </FormCell>
                        <FormCell radio>
                            <CellHeader>
                                <Radio name="radio1" value="上海" onChange={this.handleChangeCity}/>
                            </CellHeader>
                            <CellBody>上海</CellBody>
                        </FormCell>
                        <FormCell radio>
                            <CellHeader>
                                <Radio name="radio1" value="北京" onChange={this.handleChangeCity}/>
                            </CellHeader>
                            <CellBody>北京</CellBody>
                        </FormCell>
                    </Form>
                    <Form>
                        <FormCell>
                            <CellHeader>
                            <Label>票数：</Label>
                            </CellHeader>
                            <CellBody>
                                <Input type="number" placeholder="请输入购买数量" onKeyUp={this.handleChangeCount}/>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <Button onClick={this.handleSubmit}>提交购买</Button> 
                    <Toptips type="warn" show={this.state.showTopTips}> 
                        {this.state.tipsWord &&
                            this.state.tipsWord
                        }
                    </Toptips>
                </div>
            </Page> 
        )
    }
}

export default connect()(LectureRegistrationPage)


// WEBPACK FOOTER //
// ./src/pages/lecture/LectureRegistrationPage.js